import React from 'react';
import Skill from './Skill'; // Import the Skill component
import './Skills.css'; // Import the CSS file for styling

const Skills = () => {
  // Sample skills data
  const skillsData = [
    { id: 1, name: 'HTML', level: 'Advanced' },
    { id: 2, name: 'CSS', level: 'Advanced' },
    { id: 3, name: 'JavaScript', level: 'Intermediate' },
    { id: 4, name: 'React', level: 'Intermediate' },
    { id: 5, name: 'Mysql', level: 'Intermediate' },
    { id: 6, name: 'Python', level: 'Intermediate' },
  ];

  return (
    <div id="skills" className="skills-container">
      <h2 className='skill-heading'>Skills</h2>
      <div className="skills-list">
        {skillsData.map((skill) => (
          <Skill key={skill.id} name={skill.name} level={skill.level} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
